var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19 24"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.688 13.433 4.117 22.862a1.714 1.714 0 0 1-2.743-1.371V2.634a1.714 1.714 0 0 1 2.747-1.368l-.004-.003 12.571 9.429a1.715 1.715 0 0 1 .005 2.739l-.004.003z"
  })));
};
export default SvgPlay;